var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34438 13.2227C2.06348 13.204 1.91367 13.0542 1.89495 12.7733V1.98674C1.91367 1.70585 2.06348 1.55603 2.34438 1.53731H6.83877V3.7845C6.83877 4.04667 6.92304 4.26203 7.09157 4.43056C7.26011 4.5991 7.47547 4.68337 7.73764 4.68337H9.98483V12.7733C9.96611 13.0542 9.81629 13.204 9.53539 13.2227H2.34438ZM2.34438 0.188992C1.83877 0.207718 1.41742 0.385621 1.08034 0.722699C0.74326 1.05978 0.565357 1.48113 0.546631 1.98674V12.7733C0.565357 13.2789 0.74326 13.7002 1.08034 14.0373C1.41742 14.3744 1.83877 14.5523 2.34438 14.571H9.53539C10.041 14.5523 10.4624 14.3744 10.7994 14.0373C11.1365 13.7002 11.3144 13.2789 11.3331 12.7733V4.54292C11.3331 4.03731 11.1552 3.6066 10.7994 3.25079L8.27135 0.722699C7.91554 0.366894 7.4942 0.188992 7.00731 0.188992H2.34438ZM3.91742 7.38C3.50543 7.41746 3.28071 7.64218 3.24326 8.05416C3.28071 8.46615 3.50543 8.69086 3.91742 8.72832H7.96236C8.37435 8.69086 8.59907 8.46615 8.63652 8.05416C8.59907 7.64218 8.37435 7.41746 7.96236 7.38H3.91742ZM3.91742 10.0766C3.50543 10.1141 3.28071 10.3388 3.24326 10.7508C3.28071 11.1628 3.50543 11.3875 3.91742 11.4249H7.96236C8.37435 11.3875 8.59907 11.1628 8.63652 10.7508C8.59907 10.3388 8.37435 10.1141 7.96236 10.0766H3.91742Z",
    fill: "#ADB5BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.4bcfb652b624e4a04d3982d83289b0ad.svg";
export { ForwardRef as ReactComponent };